import { gql } from '@apollo/client';
export const IMPORT_RUN_FIELDS = gql `
  fragment ImportRunFields on ImportRun {
    id
    createdAt
    updatedAt
    clientId
    clientName
    importId
    importName
    numRowsImported
    totalRows
    s3Key
    startedAt
    completedAt
    status
    error
  }
`;
export const IMPORT_RUNS = gql `
  ${IMPORT_RUN_FIELDS}
  query IMPORT_RUNS($spec: ImportRunSpec!) {
    importRuns(spec: $spec) {
      total
      page
      pageSize
      items {
        ...ImportRunFields
      }
    }
  }
`;
